export default {
  abbott: '/api/v1/open-live-detail/',
  checkUidLogin: '/api/web/v2/meeting/checkuidlogin'
}
